export default {
  opened: 'opened',
  completed: 'completed',
  completeProgress: '{{from}}%-{{to}}% complete',
  noProject: 'No content to display',
  invalidColumnError: 'Can only be moved to the completed column',
};
